'use strict';

var _require = require('./Component'),
    CopyToClipboard = _require.CopyToClipboard;

module.exports = CopyToClipboard;


//////////////////
// WEBPACK FOOTER
// ./~/react-copy-to-clipboard/lib/index.js
// module id = ./node_modules/react-copy-to-clipboard/lib/index.js
// module chunks = 0